import { gql } from '@apollo/client';

import {
  LinkMobileAudioDocument,
  type LinkMobileAudioMutation,
  type LinkMobileAudioMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation LinkMobileAudio($input: LinkMobileAudioInput!) {
      linkMobileAudio(input: $input)
    }
  `;
}

export const LINK_MOBILE_AUDIO = LinkMobileAudioDocument;
export type { LinkMobileAudioMutation, LinkMobileAudioMutationVariables };
